import '../css/Info.css';
import Footer from './Footer';
import Header from './Header';
import React from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";

function Info() {
    const navigate = useNavigate();
    const location = useLocation(); // 현재 경로 감지

    return (
        <div className="Info-container">
            <Header />
            <div className="info-container">
                {/* 왼쪽 사이드 버튼 */}
                <div className="info-left-container">
                    <div
                        className={`info-contents-container ${location.pathname === "/info/model" ? "active" : ""}`}
                    >
                        <button onClick={() => navigate("/info/model")}>
                            소개글
                        </button>
                    </div>
                    <div
                        className={`info-contents-container ${location.pathname === "/info/team" ? "active" : ""}`}
                    >
                        <button onClick={() => navigate("/info/team")}>
                            팀원
                        </button>
                    </div>
                    <div
                        className={`info-contents-container ${location.pathname === "/info/use" ? "active" : ""}`}
                    >
                        <button onClick={() => navigate("/info/use")}>
                            사용법
                        </button>
                    </div>
                </div>

                {/* 오른쪽 영역 (하위 라우트 표시) */}
                <div className="info-detail-container">
                    <Outlet />
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Info;
